import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentContext = createContext({ content: null });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then((r) => setContent(r.data))
      .catch(() => {});
  }, []);

  return <ContentContext.Provider value={{ content }}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
